module.exports = __webpack_public_path__ + "img/900924193.b2bd6482.png";